import React, { useState } from "react";
import { database, ref, set, update, remove, onValue } from "./firebase";
import { useNavigate } from "react-router-dom";
import "./BillingSystem.css";
import BossNavigation from "./BossNavigation";

export default function OwnerAddUser() {
  const [newUserPhone, setNewUserPhone] = useState("");
  const [newUserName, setNewUserName] = useState("");
  const [newUserRole, setNewUserRole] = useState("staff");
  const [newUserDob, setNewUserDob] = useState(""); // 🎂 New DOB input
  const [resetPhone, setResetPhone] = useState("");
  const [resetPassword, setResetPassword] = useState("");
  const [deletePhone, setDeletePhone] = useState("");
  const [notification, setNotification] = useState("");
  const navigate = useNavigate();

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(""), 3000);
  };

  const handleAddUser = async () => {
    if (!newUserPhone.match(/^\d{10}$/) || !newUserName.trim()) {
      return showNotification("Enter valid phone and name.");
    }

    await set(ref(database, `users/${newUserPhone}`), {
      name: newUserName,
      role: newUserRole,
      password: "123456",
      dob: newUserDob || null, // ✅ Save birthday if entered
    });

    setNewUserPhone("");
    setNewUserName("");
    setNewUserRole("staff");
    setNewUserDob(""); // reset DOB input
    showNotification("✅ User added with default password: 123456");

    const message = `👋 Welcome ${newUserName},\nYou are registered at Jauhari Enterprises.\n🔐 Password: 123456\nLogin: jauharienterprises.com`;
    window.open(`https://wa.me/91${newUserPhone}?text=${encodeURIComponent(message)}`, "_blank");
  };

  const handleResetPassword = async () => {
    if (!resetPhone.match(/^\d{10}$/) || !resetPassword.trim()) {
      return showNotification("Enter valid phone and new password.");
    }

    const userRef = ref(database, `users/${resetPhone}`);
    let userExists = false;

    await new Promise((resolve) => {
      onValue(
        userRef,
        (snapshot) => {
          userExists = !!snapshot.val();
          resolve();
        },
        { onlyOnce: true }
      );
    });

    if (!userExists) {
      return showNotification("User with this phone does not exist.");
    }

    await set(ref(database, `users/${resetPhone}/password`), resetPassword);
    setResetPhone("");
    setResetPassword("");
    showNotification("🔒 Password reset successfully");

    const message = `🔐 Your password at Jauhari Enterprises has been changed.\nNew Password: ${resetPassword}\nLogin: jauharienterprises.com`;
    window.open(`https://wa.me/91${resetPhone}?text=${encodeURIComponent(message)}`, "_blank");
  };

  const bulkUpdatePasswords = async () => {
    if (!window.confirm("Set default password '123456' only for users without passwords?")) return;

    const usersRef = ref(database, "users");

    const snapshot = await new Promise((resolve) => {
      onValue(usersRef, (snap) => {
        resolve(snap);
      }, { onlyOnce: true });
    });

    const users = snapshot.val();
    if (!users) {
      showNotification("No users found to update.");
      return;
    }

    const updates = {};
    Object.entries(users).forEach(([phone, userData]) => {
      if (!userData.password) {
        updates[`${phone}/password`] = "123456";
      }
    });

    if (Object.keys(updates).length === 0) {
      showNotification("All users already have passwords set.");
      return;
    }

    await update(usersRef, updates);
    showNotification("🔄 Default passwords set for users without passwords.");
  };

  const handleDeleteUser = async () => {
    if (!deletePhone.match(/^\d{10}$/)) {
      return showNotification("Enter valid 10-digit phone number to delete.");
    }

    const userRef = ref(database, `users/${deletePhone}`);

    const userSnap = await new Promise((resolve) =>
      onValue(userRef, (snap) => resolve(snap), { onlyOnce: true })
    );

    const userData = userSnap.val();
    if (!userData) {
      return showNotification("❌ User not found.");
    }

    if (deletePhone === "9628950249" || userData.role === "owner" || userData.role === "boss") {
      return showNotification("❌ Cannot delete Owner or Boss.");
    }

    if (!window.confirm(`Are you sure you want to delete user ${userData.name}?`)) return;

    await remove(userRef);
    showNotification("🗑️ User deleted successfully.");
    setDeletePhone("");
  };

  return (
    <div className="billing-container">
      <BossNavigation />
      <div className="billing-card">
        <h2 className="billing-title">👤 Add New User</h2>

        {notification && (
          <div className="billing-notification">
            {notification}
          </div>
        )}

        <input
          type="tel"
          placeholder="📱 Phone (10 digits)"
          value={newUserPhone}
          onChange={(e) => setNewUserPhone(e.target.value)}
          maxLength={10}
          className="billing-input"
        />
        <input
          type="text"
          placeholder="🧑 Name"
          value={newUserName}
          onChange={(e) => setNewUserName(e.target.value)}
          className="billing-input"
        />
        <select
          value={newUserRole}
          onChange={(e) => setNewUserRole(e.target.value)}
          className="billing-input"
        >
          <option value="staff">Staff</option>
          <option value="manager">Manager</option>
          <option value="production">Production Manager</option>
          <option value="stock manager">Stock Manager</option>
          <option value="salesman">Salesman</option>
          <option value="special manager">Special Manager</option>
           <option value="hr">HR</option>
        </select>

        <input
          type="date"
          value={newUserDob}
          onChange={(e) => setNewUserDob(e.target.value)}
          className="billing-input"
          placeholder="🎂 Date of Birth"
          max={new Date().toISOString().split("T")[0]}
        />

        <button className="billing-button primary" onClick={handleAddUser}>
          ➕ Add User
        </button>
      </div>

      <div className="billing-card" style={{ marginTop: 40 }}>
        <h3 className="billing-subtitle">🔐 Reset User Password</h3>
        <input
          type="tel"
          placeholder="📱 Phone (10 digits)"
          value={resetPhone}
          onChange={(e) => setResetPhone(e.target.value)}
          maxLength={10}
          className="billing-input"
        />
        <input
          type="password"
          placeholder="New Password"
          value={resetPassword}
          onChange={(e) => setResetPassword(e.target.value)}
          className="billing-input"
        />
        <button className="billing-button danger" onClick={handleResetPassword}>
          🔁 Reset Password
        </button>
      </div>

      <div className="billing-card" style={{ marginTop: 40 }}>
        <h3 className="billing-subtitle">🗑️ Delete User by Phone Number</h3>
        <input
          type="tel"
          placeholder="📱 Phone (10 digits)"
          value={deletePhone}
          onChange={(e) => setDeletePhone(e.target.value)}
          maxLength={10}
          className="billing-input"
        />
        <button className="billing-button danger" onClick={handleDeleteUser}>
          🗑️ Delete User
        </button>
      </div>

      <button
        className="billing-button warning"
        onClick={bulkUpdatePasswords}
        style={{ marginTop: 20 }}
      >
        🔄 Reset All Missing Passwords to '123456'
      </button>

      <button
        className="billing-button back"
        onClick={() => navigate("/")}
        style={{ marginTop: 30 }}
      >
        🔙 Back
      </button>
    </div>
  );
}
